export const transposeAdjacencyList = (adjacencyList) => {
    // Initialize an empty adjacency list for the transposed graph
    const transposedAdjacencyList = {};
    // Initialize empty arrays for all nodes in the transposed graph
    for (const node in adjacencyList) {
        transposedAdjacencyList[node] = [];
    }
    // Iterate over the original adjacency list
    for (const node in adjacencyList) {
        const neighbors = adjacencyList[node];
        // For each neighbor of the current node, add a reverse edge
        for (const neighbor of neighbors) {
            // Ensure the neighbor exists in the transposed adjacency list
            if (!transposedAdjacencyList[neighbor]) {
                transposedAdjacencyList[neighbor] = [];
            }
            // Reverse the direction of the edge
            transposedAdjacencyList[neighbor].push(node);
        }
    }
    return transposedAdjacencyList;
};
